export { default } from './ReviewTermsModal';